module.exports = __webpack_public_path__ + "img/header-bg1.75fe5a9b.png";